import { render } from "./App.vue?vue&type=template&id=5e0c2294"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5e0c2294&lang=scss"

import exportComponent from "/Users/engkhiongsoh/dev/marketanalysis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__